<template
  src="./index.html"
  lang="html"
/>
<style
  src="../../stylus/main.css"
  lang="css">
</style>
<script>

  import  {
    alpha40,
    businessName,
    naturalRfc,
    legalRfc,
    tin,
    alpha,
    mobilePhone,
    landLine,
    email,
    sameAs,
    minLength,
    maxLength,
    numeric,
  } from "../../vendors/vue-validate/validators";

  import prvInput from "../../components/prv-input/prv-input.vue";
  import prvDropdown from "../../components/prv-dropdown/prv-dropdown.vue";
  import prvMultiSelect from '../../components/prv-multi-select/prv-multi-select.vue';

  import { CountryCallingCodes } from "../../catalogs/country-calling-codes";

  import { SignUp } from "./domain/sign-up";
  import { SignUpQualifier } from "./domain/sign-up-qualifier";
  import { LegalCatalog } from "../../domain/legal-catalog";

  export default {
    components: {
      'prv-input': prvInput,
      'prv-dropdown': prvDropdown,
      'prv-multi-select': prvMultiSelect,
    },
    data() {
      return {
        RFC:        'RFC',
        TIN:        'TIN',
        LOCAL:      'LOCAL',
        FOREIGN:    'FOREIGN',
        NATURAL:    'NATURAL',
        LEGAL:      'LEGAL',
        signUp:     new SignUp({}),
        terms:      false,
        success:    false,
        warning:{
          state:    false,
          field:    ''
        },
        error:{
          code:     500,
          state:    false
        },
        legalRfc:   null,
        naturalRfc: null,
        confirmNaturalRFC: null,
        confirmLegalRFC: null,
        phoneCodes: CountryCallingCodes,
        LEGAL_URL: LegalCatalog.getTermsAndConditionsURL(),
        PRIVACY_NOTICE_URL: LegalCatalog.getPrivacyNoticeURL(),
        ORIGIN_SIGN_UP: 'NEC',
        legalEntities: [
          { code: 'NATURAL',  description: this.$t('signup.natural-person') },
          { code: 'LEGAL',    description: this.$t('signup.moral-person') }
        ],
        origins: [
          { code: 'LOCAL',    description: this.$t('signup.national') },
          { code: 'FOREIGN',  description: this.$t('signup.international') }
        ]
      }
    },
    computed: {
      isTinValid() {
        const isValid =
          this.signUp.tin &&
          this.signUp.tin.length >= 7 &&
          this.signUp.tin.length <= 20;
        return isValid;
      },
      filledForm() {

        if (
          this.$v.signUp.$anyError ||
          !this.signUp.businessName ||
          !this.terms
        ) {
          return false;
        }

        if (this.checkOriginCode()) {

          if (this.signUp.legalEntity.code === this.NATURAL) {
            if (!this.naturalRfc || this.$v.naturalRfc.$anyError ||
                !this.confirmNaturalRFC || this.$v.confirmNaturalRFC.$anyError) {
              return false;
            }
          } else {
            if (!this.legalRfc || this.$v.legalRfc.$anyError ||
                !this.confirmLegalRFC || this.$v.confirmLegalRFC.$anyError) {
              return false;
            }
          }

          if (!this.signUp.legalEntity.code) {
            return false;
          }
        } else {
          if (!this.isTinValid) {
            return false;
          }

        }

        if (!this.signUp.names) {
          return false;
        }

        if (!this.signUp.firstSurname) {
          return false;
        }

        if (!this.signUp.position) {
          return false;
        }

        if (!this.signUp.businessName) {
          return false;
        }

        if (!this.signUp.mobilePhoneCcc) {
          return false;
        }

        if (this.signUp.origin.code === this.LOCAL) {

          if (!this.signUp.mobilePhone) {
            return false;
          }

          if (!this.signUp.landLine) {
            return false;
          }
        }

        if (this.signUp.origin.code === this.FOREIGN) {

          if (!this.signUp.foreignmobilePhone) {
            return false;
          }

          if (!this.signUp.foreignlandLine) {
            return false;
          }
        }

        if (!this.signUp.email) {
          return false;
        }

        return this.signUp.confirmEmail;
      }

    },
    methods:{
      classSpan(local){
        return {
          'sign-up__item': local,
          'sign-up__item--double': !local
        }
      },
      resetRfc() {

        this.naturalRfc = null;
        this.legalRfc   = null;
        this.signUp.rfc = null;
        this.confirmNaturalRFC = null;
        this.confirmLegalRFC = null;
      },
      checkOriginCode() {
        return this.signUp.origin.code === this.LOCAL;
      },
      resetFields() {

        if (this.checkOriginCode()) {
          this.signUp.tin = null
        } else {
          this.signUp.rfc = null;
          this.signUp.legalEntity.code = this.LEGAL;
        }
      },
      reload() {
        location.reload();
      },
      save() {
          //monterrey
          this.signUp.monterrey = false;
          if (this.filledForm) {
            if (this.checkOriginCode()) {
              this.signUp.tin = null;
              this.signUp.rfc = this.signUp.legalEntity.code === this.NATURAL ? this.naturalRfc : this.legalRfc;
            } else {
              this.signUp.rfc = null;
              this.signUp.legalEntity.code = null;
            }

            this.signUp.lang = this.$i18n.locale.toString().toUpperCase();

            this.createUser(new SignUpQualifier(this.signUp, this.checkOriginCode()));
          }
      },
      createUser(signUp) {

        fetch('/api/v1/signup', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-origin': this.ORIGIN_SIGN_UP  //Necsus
          },
          cors: 'no-cors',
          cache: 'no-cache',
          body: JSON.stringify(signUp)
        })
        .then(response => {
          switch(response.status) {

            case 201:
              this.success = true;
            break;

            case 409:
              this.warning.state = true;
              this.warning.field = this.checkOriginCode() ? this.RFC : this.TIN;
            break;

            case 400:
              this.error.state = true;
              this.error.code = 400;
            break;

            case 422:
              this.error.state = true;
              this.error.code = 422;
            break;

            default:
              this.error.state = true;
              this.error.code = response.status;
            break;
          }
        })
        .catch(response => {
            this.error.state = true;
            this.error.code = response.status;
        });
      },
      redirec() {
        location.replace(__SIGN_IN_WEB_APP_HOST__)
      }
    },
    validations: {
      legalRfc: {
        legalRfc
      },
      naturalRfc: {
        naturalRfc
      },
      confirmLegalRFC: {
        legalRfc,
        sameAsLegalRFC: sameAs('legalRfc')
      },
      confirmNaturalRFC: {
        naturalRfc,
        sameAsNaturalRFC: sameAs('naturalRfc')
      },
      signUp:{
        businessName: {
          businessName
        },
        tin: {
          tin,
          minLength: minLength(7),
          maxLength: maxLength(20)
        },
        names:{
          alpha40
        },
        firstSurname: {
          alpha40
        },
        secondSurname: {
          alpha40
        },
        position: {
          alpha
        },
        mobilePhone: {
          mobilePhone
        },
        foreignmobilePhone: {
          numeric,
          minLength: minLength(7),
          maxLength: maxLength(12)
        },
        landLine: {
          landLine
        },
        foreignlandLine: {
          numeric,
          minLength: minLength(7),
          maxLength: maxLength(12)
        },
        email: {
          email
        },
        confirmEmail: {
          email,
          sameAsEmail: sameAs('email')
        }
      }
    }
  }
</script>
